export class Broker {
  constructor(brokerInfo) {
    this.brokerName = brokerInfo.brokerName
    this.getLastOrder = brokerInfo.getLastOrder
    this.uploadOrderFile = brokerInfo.uploadOrderFile
    this.redoLastOrder = brokerInfo.redoLastOrder
    this.modelFileUrl = brokerInfo.modelFileUrl
  }
}
